import type { ReactNode } from "react";

export function Topbar({
  crumb,
  title,
  subtitle,
  right,
}: {
  crumb?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div className="topbar">
      <div style={{ minWidth: 0 }}>
        {crumb && <div className="crumb">{crumb}</div>}
        <h1>{title}</h1>
        {subtitle && <div className="topbar-subtitle">{subtitle}</div>}
      </div>
      {right && <div className="row">{right}</div>}
    </div>
  );
}
